export const PLUGIN_NAME = "Google Drive"
export const MIME_TYPE_FOLDER = "application/vnd.google-apps.folder"
export const GOOGLE_DRIVE_FILE_SCOPE =
  "https://www.googleapis.com/auth/drive.file"
export const GOOGLE_DRIVE_FILE_SCOPES = [GOOGLE_DRIVE_FILE_SCOPE]
